/**
 * Eight Queens chess game
 * Status box
 */
import React, { Component } from "react";
import "./Status.css";

class Status extends Component {
  render() {
    setTimeout(() => {
      if (
        this.props.queensOnBoard === 8 &&
        this.props.queensUnderAttack === 0 &&
        this.props.gameStat !== "playing"
      ) {
        this.props.gameWon();
      }
    }, 700);

    return (
      <div className="EightQueens-status">
        <b>{this.props.queensOnBoard}</b> Queens on board
        <br />
        <b>{this.props.queensUnderAttack}</b> Queens attacked
        <br />
      </div>
    );
  }
}

export default Status;
